import React from "react";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Image from "next/image";
import { Link } from "react-scroll";
import { TOOL_BAR_HEIGHT } from "lib/settings";
import renderHTML from "lib/render-html";
import Breadcrumbs from "components/common/Breadcrumbs";
import OgImage from "components/common/OgImage";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    imageBox: {
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
    logoList: {
      margin: 0,
      padding: 0,
      listStyle: "none",
      display: "flex",
      "& li": {
        "&:not(:last-child)": {
          marginRight: theme.spacing(0.5),
        },
      },
    },
  })
);
const CoursesBanner: React.FC<CoursesBannerProps> = ({ content }) => {
  const classes = useStyles();

  return (
    <>
      <Box paddingY={[2, 3, 4, 5, 6]} className={classes.root}>
        <Container>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Typography variant="h1" gutterBottom>
                {content.heading}
              </Typography>
              <Typography paragraph>{renderHTML(content.paragraph)}</Typography>

              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4} lg={4}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    fullWidth
                    component={Link}
                    to="view-courses"
                    spy={true}
                    offset={-TOOL_BAR_HEIGHT}
                    duration={500}
                  >
                    View Courses
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              className={classes.imageBox}
            >
              <Image
                src={
                  process.env.NEXT_PUBLIC_ADMIN_URL +
                  "storage/images/" +
                  content.imageUrl
                }
                width={400}
                height={250}
                alt={content.imageAlt}
                style={{ width: "100%", height: "auto" }}
              />
            </Grid>
          </Grid>
        </Container>
      </Box>
      <OgImage
        src={
          process.env.NEXT_PUBLIC_ADMIN_URL +
          "storage/images/" +
          content.imageUrl
        }
      />
      {/* Breadcrumbs */}
      <Breadcrumbs data={content.breadcrumbs} borderBottom={true} />
    </>
  );
};

export default CoursesBanner;
